import React from 'react';
import type { LocaleProviderProps } from './LocaleProvider';
import { LocaleProvider } from './LocaleProvider';
import type { UiSettingsProviderProps } from './UiSettingsProvider';
import { UiSettingsProvider } from './UiSettingsProvider';

/**
 * A wrapper for the various providers needed for the PrimeX Quote workflows.
 * This includes the LocaleProvider and UiSettingsProvider.
 */
const PrimeXQuoteProviders = (props: PrimeXQuoteProvidersProps) => {
  return (
    <LocaleProvider {...props}>
      <UiSettingsProvider {...props}>{props.children}</UiSettingsProvider>
    </LocaleProvider>
  );
};

export default PrimeXQuoteProviders;

type PrimeXQuoteProvidersProps = LocaleProviderProps & UiSettingsProviderProps;
